/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Colleagues_Agenda_NoteInputs */



/**
* | output |
* | --- |
* | "Through your calendar in Wundo, you can add or delete conversations at any time." |
*
* @param {Onboarding_Colleagues_Agenda_NoteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_colleagues_agenda_note = /** @type {((inputs?: Onboarding_Colleagues_Agenda_NoteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Colleagues_Agenda_NoteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Via je agenda in Wundo kan je op elk moment gesprekken toevoegen of verwijderen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Via votre agenda dans Wundo, vous pouvez ajouter ou supprimer des entretiens à tout moment.")
	return /** @type {LocalizedString} */ ("Through your calendar in Wundo, you can add or delete conversations at any time.")
});